import { render, staticRenderFns } from "./PedidoCuentaDelete.vue?vue&type=template&id=0a72831c"
import script from "./PedidoCuentaDelete.vue?vue&type=script&lang=js"
export * from "./PedidoCuentaDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports